/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesServicesDtosGetServicePriceHistoryResponse,
  FacilityFlowCoreModulesServicesDtosServiceDto,
  FacilityFlowCoreModulesServicesWorkflowsCreateServiceRequest,
  FacilityFlowCoreModulesServicesWorkflowsCreateServiceResponse,
  FacilityFlowCoreModulesServicesWorkflowsUpdateServiceRequest,
  GetApiV1ServicesParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getServices = () => {
/**
 * @summary Create a new service
 */
const postApiV1Services = (
    facilityFlowCoreModulesServicesWorkflowsCreateServiceRequest: FacilityFlowCoreModulesServicesWorkflowsCreateServiceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesWorkflowsCreateServiceResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesWorkflowsCreateServiceResponse>(
      {url: `/api/v1/services`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesServicesWorkflowsCreateServiceRequest
    },
      options);
    }
  /**
 * @summary Search services
 */
const getApiV1Services = (
    params?: GetApiV1ServicesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosServiceDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosServiceDto[]>(
      {url: `/api/v1/services`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Get a service by ID
 */
const getApiV1ServicesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosServiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosServiceDto>(
      {url: `/api/v1/services/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update a service
 */
const putApiV1ServicesId = (
    id: string,
    facilityFlowCoreModulesServicesWorkflowsUpdateServiceRequest: FacilityFlowCoreModulesServicesWorkflowsUpdateServiceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosServiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosServiceDto>(
      {url: `/api/v1/services/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesServicesWorkflowsUpdateServiceRequest
    },
      options);
    }
  /**
 * @summary Delete a service
 */
const deleteApiV1ServicesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/services/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Get price history for a service
 */
const getApiV1ServicesIdPriceHistory = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosGetServicePriceHistoryResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosGetServicePriceHistoryResponse>(
      {url: `/api/v1/services/${id}/price-history`, method: 'GET'
    },
      options);
    }
  return {postApiV1Services,getApiV1Services,getApiV1ServicesId,putApiV1ServicesId,deleteApiV1ServicesId,getApiV1ServicesIdPriceHistory}};
export type PostApiV1ServicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getServices>['postApiV1Services']>>>
export type GetApiV1ServicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getServices>['getApiV1Services']>>>
export type GetApiV1ServicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getServices>['getApiV1ServicesId']>>>
export type PutApiV1ServicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getServices>['putApiV1ServicesId']>>>
export type DeleteApiV1ServicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getServices>['deleteApiV1ServicesId']>>>
export type GetApiV1ServicesIdPriceHistoryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getServices>['getApiV1ServicesIdPriceHistory']>>>
